import type { Translatable } from '@hrlabs/shared-types';
import { QuillEditor } from './QuillEditor';

type Props = {
  label: string;
  value: Translatable;
  onChange: (v: Translatable) => void;
  required?: boolean;
  rich?: boolean;
  rows?: number;
};

/** Side-by-side BG / EN inputs bound to one `{ en, bg }` value. */
export function BilingualField({ label, value, onChange, required, rich, rows = 3 }: Props) {
  const set = (locale: 'en' | 'bg') => (text: string) => onChange({ ...value, [locale]: text });

  return (
    <div className="mb-3">
      <label className="form-label fw-semibold">
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <div className="row g-2">
        {(['bg', 'en'] as const).map((loc) => (
          <div className="col-md-6" key={loc}>
            <div className="small text-muted text-uppercase mb-1">{loc}</div>
            {rich ? (
              <QuillEditor value={value[loc]} onChange={set(loc)} />
            ) : rows > 1 ? (
              <textarea
                className="form-control"
                rows={rows}
                value={value[loc]}
                onChange={(e) => set(loc)(e.target.value)}
              />
            ) : (
              <input
                className="form-control"
                value={value[loc]}
                onChange={(e) => set(loc)(e.target.value)}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
